"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _lodash = require("lodash");
var _htmlReactParser = _interopRequireWildcard(require("html-react-parser"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var options = {
  replace: function replace(domNode) {
    if ((0, _lodash.get)(domNode, 'attribs.href')) {
      return /*#__PURE__*/_react["default"].createElement("a", {
        href: domNode.attribs.href,
        target: "_blank",
        rel: "noopener noreferrer"
      }, (0, _htmlReactParser.domToReact)(domNode.children));
    }
    return domNode;
  }
};
function HtmlParsedText(props) {
  var className = props.className,
    value = props.value;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('html-parsed-text', className)
  }, (0, _htmlReactParser["default"])(_dompurify["default"].sanitize(value), options));
}
HtmlParsedText.propTypes = {
  className: _propTypes["default"].string,
  value: _propTypes["default"].string.isRequired
};
HtmlParsedText.defaultProps = {
  className: ''
};
var _default = exports["default"] = HtmlParsedText;